import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { FAQForms, fetchFAQRecord, fetchFAQUpdate, IFAQ } from '../../../../features/faq';
import { useEntityUpdate } from '../../../../features/entities/hooks';
import { PreloaderWrapper } from '../../../../components/preloader-wrapper';
import { PageTitle } from '../../../../components/page-title';
import { CabinetContainer } from '../../../../components/cabinet-container';
import { ROUTE_FAQ } from '../../../../common/constants';
import { get } from '../../../../common/utils';

export const FAQUpdatePage: FC = () => {
  const { t } = useTranslation();
  const { isFetching, isUpdating, data, handleValid } = useEntityUpdate<IFAQ>({
    entity: 'faq',
    recordThunk: fetchFAQRecord,
    updateThunk: fetchFAQUpdate,
    nextPath: ROUTE_FAQ,
  });

  const defaultValues = { ...data };

  return (
    <>
      <Helmet>
        <title>{t('faq.update')}</title>
      </Helmet>
      <CabinetContainer>
        <PageTitle title={t('faq.update.title')} mb={3} />
        <PreloaderWrapper isLoading={isFetching}>
          <FAQForms
            onValid={handleValid}
            defaultValues={defaultValues}
            isLoading={isUpdating}
            key={get(data, 'id')}
          />
        </PreloaderWrapper>
      </CabinetContainer>
    </>
  );
};
